import { FC, useMemo } from 'react';
import styles from './index.module.less';
import { isEqual, isNotEmpty, replaceEmpty } from '@lhb/func';
import cs from 'classnames';
import IconFont from '@/common/components/IconFont';
import { Col, Row } from 'antd';

/**
 * @Description 小区卡片
 */
const Card:FC<{
  data: any;
  curDetail: any;
  setCurDetail: any;
}> = ({
  data = {},
  curDetail,
  setCurDetail
}) => {

  const isActive = useMemo(() => {
    if (!curDetail) return false;
    // 与数据部门确定，会出现名字相同的数据，但是其他字段会不同
    return isEqual(data, curDetail);
  }, [curDetail]);

  const dataList = useMemo(() => {
    const list = [
      {
        name: '户数',
        value: (data?.houseHolds)
      },
      {
        name: '居住人数',
        value: (data?.liveNum)
      },
      {
        name: '建筑年份',
        value: (data?.buildTime)
      },
      {
        name: '加权户数',
        value: (data?.weightedHomeNumber)
      },
    ];
    return list;
  }, [data]);
  return (
    <div className={cs(styles.cardCon, isActive && styles.active)} onClick={() => setCurDetail(data)}>
      { isActive && <div className={styles.activeIcon}>
        <IconFont
          iconHref='iconcheckbox_select'
        />
      </div>}
      <div className={styles.leftCon}>
        <IconFont
          iconHref='icona-bianzubeifen4'
        />
      </div>
      <div className={styles.rightCon}>
        <div className={styles.name}>{data.name}</div>
        <div className={styles.descCon}>
          {/* 如果每一项都没数据则展示地址 */}
          {dataList.filter(item => isNotEmpty(item.value))?.length
            ? <Row className={styles.descItem} gutter={[12, 6]}>
              {dataList.map(itm => <Col span={12}>{itm.name}:{replaceEmpty(itm.value)}</Col>)}
            </Row>
            : <div className={styles.address}>
              {data?.address}
            </div>}
        </div>
      </div>
    </div>
  );
};


export default Card;
